[
  {
    "ruleName": "PWD_RUL_MIN_8_MAX_15_CHRS",
    "ruleValidator": "validateMaxLength",
    "ruleText": "Minimum 8 and Maximum 15 Characters"
  },
  {
    "ruleName": "PWD_RUL_ATLST_1_LCASE",
    "ruleValidator": "validateLowerCase",
    "ruleText": "1 Small Letter minimum"
  },
  {
    "ruleName": "PWD_RUL_ATLST_1_UCASE",
    "ruleValidator": "validateUpperCase",
    "ruleText": "1 Capital Letter minimum"
  },
  {
    "ruleName": "PWD_RUL_ATLST_1_NUMBER",
    "ruleValidator": "validateNumeric",
    "ruleText": "1 Number minimum"
  },
  {
    "ruleName": "PWD_RUL_ATLST_1_SP_CHR",
    "ruleValidator": "validateNonAlphaNumeric",
    "ruleText": "1 Symbol (!,@,#,$,%,^,&,*) minimum"
  }
]